import { render } from "./SubrogationDocsTable.vue?vue&type=template&id=1e5fcf44&scoped=true"
import script from "./SubrogationDocsTable.vue?vue&type=script&lang=js"
export * from "./SubrogationDocsTable.vue?vue&type=script&lang=js"

import "./SubrogationDocsTable.vue?vue&type=style&index=0&id=1e5fcf44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5fcf44"]])

export default __exports__